export interface Channel {
  id: number;
  twitch_id: string;
  username: string;
  display_name: string;
  is_active: boolean;
  youtube: YouTubeSettings;
}

export interface YouTubeSettings {
  reward_name?: string;
  enabled: boolean;
}

export interface TikTokSettings {
  reward_name?: string;
  enabled: boolean;
}

export interface Video {
  id: number;
  youtube_id?: string;
  youtube_url?: string;
  tiktok_id?: string;
  tiktok_url?: string;
  integration?: 'youtube' | 'tiktok';
  video_title?: string;
  video_duration?: number;
  requested_by: string;
  status: VideoStatus;
  queue_position?: number;
  created_at: string;
  started_at?: string;
}

export enum VideoStatus {
  PENDING = 'pending',
  PLAYING = 'playing',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
}

export interface WebSocketMessage {
  type: string;
  channel_id: number;
  [key: string]: any;
}

export interface QueueStats {
  current_video?: Video;
  pending_count: number;
  estimated_duration_seconds: number;
  estimated_duration_minutes: number;
}